export enum CONTENT_SECTION {
  hwr = 'hwr',
  eap = 'eap',
}
